var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4824 17.0234C13.722 17.0234 13.9329 16.9479 14.1152 16.7969C14.2975 16.6458 14.3887 16.4375 14.3887 16.1719V14.6719H15.3887C15.6022 14.6719 15.7663 14.6068 15.8809 14.4766C16.0007 14.3411 16.0605 14.1823 16.0605 14C16.0605 13.8125 16.0007 13.651 15.8809 13.5156C15.7663 13.3802 15.6022 13.3125 15.3887 13.3125H14.3965V7.10156C14.3965 6.65885 14.2689 6.33073 14.0137 6.11719C13.7637 5.89844 13.446 5.78906 13.0605 5.78906C12.7324 5.78906 12.4408 5.86458 12.1855 6.01562C11.9303 6.16146 11.6986 6.40104 11.4902 6.73438L7.43555 13.2578C7.40951 13.2995 7.38607 13.3438 7.36523 13.3906C7.34961 13.4375 7.33659 13.487 7.32617 13.5391C7.32096 13.5911 7.31836 13.6432 7.31836 13.6953C7.31836 13.9453 7.39909 14.1719 7.56055 14.375C7.72721 14.5729 7.94076 14.6719 8.20117 14.6719H12.5527V16.1719C12.5527 16.4375 12.6465 16.6458 12.834 16.7969C13.0215 16.9479 13.2376 17.0234 13.4824 17.0234ZM9.17773 13.3125L12.5527 7.72656V13.3125H9.17773Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbove);
export default __webpack_public_path__ + "static/media/above.ad8248a0.svg";
export { ForwardRef as ReactComponent };